import axios from 'axios';
import { EventResponse, PhotoResponse } from '../types';
import { API_BASE } from './api';

const MAX_THUMB_SIDE = 800;

export const processImageForUpload = (file: File): Promise<{ original: File; thumbnail: File }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      const { width, height } = img;

      // Thumbnail — max 800px en lado largo
      const scale = Math.min(1, MAX_THUMB_SIDE / Math.max(width, height));
      const tW = Math.round(width * scale);
      const tH = Math.round(height * scale);

      const thumbCanvas = document.createElement('canvas');
      thumbCanvas.width = tW;
      thumbCanvas.height = tH;
      thumbCanvas.getContext('2d')!.drawImage(img, 0, 0, tW, tH);

      const isHeic = /\.(heic|heif)$/i.test(file.name) ||
        file.type === 'image/heic' || file.type === 'image/heif';

      thumbCanvas.toBlob((thumbBlob) => {
        if (!thumbBlob) { reject(new Error('No se pudo generar thumbnail')); return; }
        const thumbName = file.name.replace(/\.[^.]+$/, '_thbmn.jpg');
        const thumbnail = new File([thumbBlob], thumbName, { type: 'image/jpeg' });

        if (isHeic) {
          // Convertir original HEIC a JPG via canvas
          const origCanvas = document.createElement('canvas');
          origCanvas.width = width;
          origCanvas.height = height;
          origCanvas.getContext('2d')!.drawImage(img, 0, 0);
          origCanvas.toBlob((origBlob) => {
            if (!origBlob) { reject(new Error('No se pudo convertir HEIC')); return; }
            const origName = file.name.replace(/\.[^.]+$/, '.jpg');
            const original = new File([origBlob], origName, { type: 'image/jpeg' });
            resolve({ original, thumbnail });
          }, 'image/jpeg', 0.92);
        } else {
          resolve({ original: file, thumbnail });
        }
      }, 'image/jpeg', 0.82);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('No se pudo leer la imagen'));
    };

    img.src = url;
  });
};

export const guestService = {
  async getPublicEvent(eventCode: string): Promise<EventResponse> {
    const res = await axios.get(`${API_BASE}/events/${eventCode}/public`);
    return res.data;
  },

  async getGallery(eventCode: string): Promise<PhotoResponse[]> {
    const res = await axios.get(`${API_BASE}/events/${eventCode}/gallery`);
    return res.data;
  },

  async uploadPhoto(
    eventCode: string,
    file: File,
    thumbnail: File,
    name: string,
    email: string
  ): Promise<PhotoResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('thumbnail', thumbnail);
    formData.append('name', name);
    formData.append('email', email);
    const res = await axios.post(`${API_BASE}/events/${eventCode}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  async deleteOwnPhoto(eventCode: string, photoId: number, token: string): Promise<void> {
    await axios.delete(`${API_BASE}/events/${eventCode}/photos/${photoId}?token=${encodeURIComponent(token)}`);
  },
};
